/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Hub_HintInputs */

const en_us2_invite_hub_hint = /** @type {(inputs: Invite_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your personal invite, for anyone who wants to train with you`)
};

const pt_br2_invite_hub_hint = /** @type {(inputs: Invite_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu convite pessoal, para quem quer treinar com você`)
};

const pt_pt2_invite_hub_hint = /** @type {(inputs: Invite_Hub_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu convite pessoal, para quem quer treinar com você`)
};

/** @type {(inputs: Invite_Hub_HintInputs) => LocalizedString} */
const es_419_invite_hub_hint = en_us2_invite_hub_hint;

/** @type {(inputs: Invite_Hub_HintInputs) => LocalizedString} */
const fr_fr2_invite_hub_hint = en_us2_invite_hub_hint;

/** @type {(inputs: Invite_Hub_HintInputs) => LocalizedString} */
const de_de2_invite_hub_hint = en_us2_invite_hub_hint;

/** @type {(inputs: Invite_Hub_HintInputs) => LocalizedString} */
const it_it2_invite_hub_hint = en_us2_invite_hub_hint;

/**
* | output |
* | --- |
* | "Your personal invite, for anyone who wants to train with you" |
*
* @param {Invite_Hub_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_hub_hint = /** @type {((inputs?: Invite_Hub_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Hub_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_hub_hint(inputs)
	if (locale === "es-419") return es_419_invite_hub_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_hub_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_hub_hint(inputs)
	if (locale === "de-DE") return de_de2_invite_hub_hint(inputs)
	if (locale === "it-IT") return it_it2_invite_hub_hint(inputs)
	return en_us2_invite_hub_hint(inputs)
});
export { invite_hub_hint as "invite.hub_hint" }